/**
 * How close to expiry a token may get before `getValidToken` refreshes it. The single tunable
 * that defines "too close to expired to trust." Overridable per manager.
 */
export const DEFAULT_REFRESH_THRESHOLD_MS = 60_000;
